// extracted by mini-css-extract-plugin
export default {"tag":"Values_tag__9lMgk","addTag":"Values_addTag__qsiyo"};